export default __webpack_public_path__ + "static/media/card1.072c62c9.png";